import * as React from "../../_snowpack/pkg/react.js";
const SingleLine = ({text}) => {
  return text && text.length ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("span", null, text), /* @__PURE__ */ React.createElement("br", null)) : /* @__PURE__ */ React.createElement(React.Fragment, null);
};
export default SingleLine;
